"use strict";

const MuniCulvertsDataListController = function () {
  var inited = false;
  var config = null;

  var init = function (reInitialize = false) {
    if (inited && !reInitialize) {
      render();
    } else {
      inited = true;
      config = {
        prepareDataCallback: _prepareMuniMCulvert,
        template: "list/muniCulvertsDataList.njk",
        layerName: "muniCulvert",
      };
      DataList.init(config);
      initialRender();
      loadListeners();
      DataList.loadDomListeners();
      DataList.loadDomListeners([{ target: ".open-fact-sheet", callback: openFactSheet }]);
    }
  };

  var loadListeners = function () {
    $(".data-list-container").off("click", ".map-button");
    $(".data-list-container").on("click", ".map-button", showMarkerOnMap);

    $(".data-list-container").off("click", ".open-hard-asset-inventory");
    $(".data-list-container").on(
      "click",
      ".open-hard-asset-inventory",
      HardAssetInventoryModalController.onOpenInventoryClick,
    );
  };

  var openFactSheet = function () {
    const id = DataList.getDataFromRow($(this)).id;
    UrlRoutes.go("culvert-fact-sheet", { id });
    Analytics.sendDataListEvent("open_factsheet", "culverts");
  };

  var showMarkerOnMap = function () {
    var $tr = $(this).parents("tr");
    var id = $tr.data("id");

    MapFunctions.openPopupById(id);
  };

  var initialRender = function () {
    DataList.setSorting("name", false);
    render();
  };

  var render = function () {
    DataList.render(config);
  };

  var _prepareMuniMCulvert = function (muniCulverts) {
    for (const culvert of muniCulverts) {
      culvert.lastInspectionDate = culvert.routine[culvert.routine.length - 1];
      culvert.lastInspectionDisplayDate = culvert.lastInspectionDate
        ? DateTime.dateToGroupDisplayDate(culvert.lastInspectionDate)
        : null;
    }
    sortMuniCulvertsBy(muniCulverts);

    return {
      rows: muniCulverts,
      options: {},
    };
  };

  var sortMuniCulvertsBy = function (muniCulverts) {
    const alphaSorter = SortUtilities.alphaSorter;

    var sortersDict = {
      name: alphaSorter,
      lineServiceType: alphaSorter,
      culvertType: alphaSorter,
      material: alphaSorter,
      cof: SortUtilities.cofSorter,
      lastInspectionDate: DateTime.dateComparator,
    };
    DataList.sortWithDict(muniCulverts, sortersDict);
  };

  return {
    init,
  };
};

module.exports = MuniCulvertsDataListController();

const DataList = require("../mapFunctions/dataList");
const SortUtilities = require("../general/sortUtilities.js");
const MapFunctions = require("../mapFunctions/mapFunctions.js");
const UrlRoutes = require("../routes/urlRoutes");
const Analytics = require("../general/analytics");
const HardAssetInventoryModalController = require("./hardAssetInventoryModalController");
const DateTime = require("../dateTime");
